module.exports = __webpack_public_path__ + "img/img_character_sp.c980bb32.png";